import React, { useRef } from "react";
import { Link } from "react-router-dom";
import NavbarCustomer from "../../components/NavbarCustomer";
import Footer from "../../components/webComps/Footer";
import { MdKeyboardArrowRight } from "react-icons/md";
import heroImg from "../../assets/pics/career-hero.jpg";
import team1 from "../../assets/pics/career-team1.png";
import team2 from "../../assets/pics/career-team2.png";
import team3 from "../../assets/pics/career-team3.png";
import team4 from "../../assets/pics/career-team4.png";
import career from "../../assets/pics/career.png";
import cultureImg from "../../assets/pics/career-culture.png";

const Careers = ({ filters, setFilters }) => {
  const heroAfterRef = useRef(null);

  const scrollToHeroAfter = () => {
    if (heroAfterRef.current) {
      heroAfterRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="w-full min-h-screen">
      <NavbarCustomer filters={filters} setFilters={setFilters} />
      <div ref={heroAfterRef}>
        <div className="md:h-[444px] h-[228px] w-full relative md:px-0">
          <img
            src={heroImg}
            alt="career"
            className="h-full w-full object-cover"
          />
          <div className="absolute top-0 left-0 bg-[#2a1f17] bg-opacity-80 w-full h-full text-center text-white">
            <div className="w-full h-full flex justify-center items-center  relative md:px-0 px-5">
              <div>
                <h1 className="md:text-[64px] text-[32px]  md:font-medium font-semibold">
                  Join our team
                </h1>
                <p className="md:text-2xl text-[16px]">
                  Redefine venue search and discovery with us.
                </p>
              </div>
              <div className="absolute top-0 left-0  text-center w-full  md:flex hidden justify-start items-center">
                <div className="flex justify-start gap-1 items-center w-[90%] mx-auto mt-5">
                  <Link to="/" className="text-[14px] text-[#B0B0B0]">
                    Home
                  </Link>
                  <MdKeyboardArrowRight className="text-white text-xl inline-block" />
                  <Link to="#" className="text-[#FE4747] text-[14px]">
                    Career
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-[#F8F8F8] w-full md:pt-20 pb-0 pt-5">
          <div className="w-[90%] mx-auto">
            <div className="md:h-[430px] h-[181px] w-full">
              <img
                src={cultureImg}
                alt="culture"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="md:mt-10 mt-6">
              <h1 className="md:text-[40px] text-2xl font-semibold text-center text-[#222222]">
                Our Culture
              </h1>
              <p className="md:text-[20px] text-[14px] mt-5 text-[#222222] text-justify">
                At Find My Venue, we believe that exceptional work starts with
                an inspiring culture. We value collaboration, creativity, and
                inclusivity, creating an environment where everyone feels
                empowered to share ideas and contribute to our mission. Our team
                is united by a shared passion for transforming the events
                industry, and together, we embrace a growth mindset that keeps
                us curious, innovative, and constantly evolving. Here, your
                voice matters, your growth is supported, and every success is
                celebrated.
              </p>
            </div>
          </div>
        </div>

        {/* meet our team */}
        {/* <div className="bg-[#F8F8F8] md:py-10 py-5 flex justify-center items-center gap-2 flex-col">
          <h1 className="text-[40px] font-semibold text-center text-[#222222] md:block hidden">
            Meet Our Team
          </h1>
          <div className="md:mt-5 mt-0 flex jutsify-center items-center md:w-[75%] w-[95%]">
            <div className="flex flex-wrap justify-center items-center md:gap-7 gap-5 mx-auto">
              <div className="md:w-[187px] w-[160px]">
                <div className="md:h-[187px] h-[160px] w-full ">
                  <img
                    src={team1}
                    alt="team1"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="flex justify-center items-center p-3">
                  <div>
                    <h1 className="text-[20px] text-center font-semibold text-[#222222]">
                      Kushal Kahar
                    </h1>
                    <p className="text-[14px] text-center text-[#717171]">
                      Customer Operation Manager
                    </p>
                  </div>
                </div>
              </div>
              <div className="md:w-[187px] w-[160px]">
                <div className="md:h-[187px] h-[160px] w-full ">
                  <img
                    src={team2}
                    alt="team2"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="flex justify-center items-center p-3">
                  <div>
                    <h1 className="text-[20px] text-center font-semibold text-[#222222]">
                      Kushal Kahar
                    </h1>
                    <p className="text-[14px] text-center text-[#717171]">
                      Customer Operation Manager
                    </p>
                  </div>
                </div>
              </div>
              <div className="md:w-[187px] w-[160px]">
                <div className="md:h-[187px] h-[160px] w-full ">
                  <img
                    src={team3}
                    alt="team3"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="flex justify-center items-center p-3">
                  <div>
                    <h1 className="text-[20px] text-center font-semibold text-[#222222]">
                      Kushal Kahar
                    </h1>
                    <p className="text-[14px] text-center text-[#717171]">
                      Customer Operation Manager
                    </p>
                  </div>
                </div>
              </div>
              <div className="md:w-[187px] w-[160px]">
                <div className="md:h-[187px] h-[160px] w-full ">
                  <img
                    src={team4}
                    alt="team4"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="flex justify-center items-center p-3">
                  <div>
                    <h1 className="text-[20px] text-center font-semibold text-[#222222]">
                      Kushal Kahar
                    </h1>
                    <p className="text-[14px] text-center text-[#717171]">
                      Customer Operation Manager
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="bg-[#F8F8F8] md:pt-5 pt-0 md:pb-20 pb-10 w-full">
          <div className="w-[90%] mx-auto flex md:flex-row flex-col-reverse justify-between items-center">
            <div className="md:w-[48%] w-full">
              <h1 className="md:text-[40px] text-[24px] md:text-left text-center font-semibold text-[#222222] md:mt-0 mt-9">
                Working at Findmyvenue
              </h1>
              <p className="md:text-[20px] text-[14px] text-[#222222] mt-5 text-justify">
                We’re committed to staying responsive and agile, adapting
                quickly to the needs of our users and the industry.
              </p>
              <ol className="mt-2 list-disc pl-5">
                <li className="md:text-[20px] text-[14px] text-[#222222]">
                  <span className="font-medium">Growth Opportunities: </span>We
                  believe in the continuous growth of our team because when you
                  grow, we grow.
                </li>
                <li className="md:text-[20px] text-[14px] text-[#222222]">
                  <span className="font-medium">Passion in Action: </span>Work
                  with passion and drive real change in the industry.
                </li>
                <li className="md:text-[20px] text-[14px] text-[#222222]">
                  <span className="font-medium">
                    Inclusive & Diverse Team:{" "}
                  </span>
                  Our team thrives on diversity, valuing perspectives from every
                  background.
                </li>
                <li className="md:text-[20px] text-[14px] text-[#222222]">
                  <span className="font-medium">Career Development: </span>
                  Unlock your potential with opportunities to learn, lead, and
                  excel.
                </li>
                <li className="md:text-[20px] text-[14px] text-[#222222]">
                  <span className="font-medium">Empowering Your Voice: </span>
                  Every idea matters here; we encourage you to make an impact.
                </li>
                <li className="md:text-[20px] text-[14px] text-[#222222]">
                  <span className="font-medium">
                    Dynamic Work Environment:{" "}
                  </span>
                  Our culture embraces your unique strengths and ambitions,
                  fostering an environment where you can innovate, grow, and
                  thrive.
                </li>
              </ol>
              <Link
                to="https://www.linkedin.com/company/find-my-venue-uae"
                className="bg-[#FE4747] md:flex hidden justify-center items-center text-[20px] mt-5 rounded-lg w-[250px] h-[48px] text-white"
              >
                Connect to LinkedIn
              </Link>
            </div>
            <div className="md:w-[48%] w-full md:h-[287px] h-[181px]">
              <img
                src={career}
                alt="team1"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer onScrollDownClick={scrollToHeroAfter} />
    </div>
  );
};

export default Careers;
